import { Branded } from '@library/type-utils'
import { composeFetch, composeParser } from '@library/http'
import { parseGoustoBasicResponse } from '@library/http/parsers'
import { addPath, auth, composeRequest, setServiceUrl, setQueryParam, setMethod, sendJSON } from '@library/http/requests'

export type UserID = Branded<string, 'UserId'>

type CardCheckoutBody = {
  payment_provider: 'checkout'
  card_token: string
  active: number
}

type CustomerPaymentUpdateBody = {
  user_id: UserID
  is_default: 1
  type: string
  card: CardCheckoutBody
  '3ds': boolean
  success_url: string
  failure_url: string
}

type CustomerPaymentUpdateResponseData = {
  transactionId: string
  reference: string
  redirectLink: string
  message: string
  paymentStatus: string
  cardToken: string
}

type CustomerPaymentUpdateResponse = {
  status: string
  data: CustomerPaymentUpdateResponseData
}

type CardDetails = {
  holder: string,
  number: string,
  type: string,
  cardToken: string,
  paymentProvider: string,
  expiryMonth: number,
  expiryYear: number,
}

type PayPalDetails = {
  cardToken: string,
  paymentProvider: 'paypal'
}

type ApplePayDetails =  {
  cardToken: string,
  paymentProvider: 'applepay'
}

type PaymentMethod = {
  method: 'paypal' | 'applepay',
  name: string,
  isDefault: boolean,
  details: PayPalDetails | ApplePayDetails ,
}

export type CardPaymentMethod = {
  method: 'card',
  name: string,
  isDefault: boolean,
  details: CardDetails,
}

type PaymentMethodData = {
  status: string,
  data: {
    type: 'payment-method',
    attributes: CardPaymentMethod | PaymentMethod,
  },
}

const paymentRequest = (userId: UserID) => composeRequest(
  setServiceUrl('paymentmethodquery'),
  addPath('payment-methods'),
  setQueryParam('userId', userId),
  auth
)

export const fetchPaymentDetails = (userId: UserID) => composeFetch(
  paymentRequest(userId),
  composeParser(
    parseGoustoBasicResponse,
    (basicResponse) => basicResponse as PaymentMethodData,
    (response) => response.data.attributes,
  )
)()

const customerPaymentUpdateRequest = composeRequest(
  setServiceUrl('customers', 2),
  addPath((params) => `customers/${params.user_id}/payment_methods`),
  setMethod('POST'),
  sendJSON<CustomerPaymentUpdateBody>(),
  auth,
)

export const updateCustomerPaymentDetails = composeFetch(
  customerPaymentUpdateRequest,
  composeParser(
    parseGoustoBasicResponse,
    (basicResponse: unknown) => basicResponse as CustomerPaymentUpdateResponse,
    (response: CustomerPaymentUpdateResponse) => response.data,
  ),
)

